import { classNames } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './TableValue.scss';
/**
 * @component TableValue
 * @since 1.0.0
 */
export function TableValue(props) {
    const { style, label, picto, value, primary } = Object.assign({ style: 'normal' }, props);
    const className = classNames('table-value', 'table-value--' + style, { 'table-value--is-primary': primary }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "table-value-head" }, picto && React.createElement(Icon, { className: "table-value-picto", value: picto })),
        React.createElement("div", { className: "table-value-body" },
            value && React.createElement(Text, { className: "table-value", value: value }),
            label && React.createElement(Text, { className: "table-value-label", value: label }))));
}
